"use strict";


/**
 * @type Controller
 * @name stationAdd_ctrl
 * @packageName stationAdd_dialog_ctrl.js
 *
 */
class stationAdd_ctrl {


    constructor($scope, $mdDialog, $http, organisation) {

        $scope.$http = $http;
        this.$mdDialog = $mdDialog;
        this.$scope = $scope;

        //Attach dependicies to class root
        $scope.$mdDialog = $mdDialog;

        $scope.status = {
            error: false,
            errorMessages: [],
            sending: false
        };

        $scope.organisation = organisation;

        //Close dialog
        $scope.hideDialog = () => {
            this.cancelButton();
        };

        $scope.checkIfSystemNameExists = (systemName) => {
            $http.get('/station/checksystemname/' + systemName).then(response => {
                if (response.data !== true) {
                    $scope.stationForm.system_name.$setValidity('unique', true);
                } else {
                    $scope.stationForm.system_name.$setValidity('unique', false);
                }
            });
        };

        const sanitizeSystemName = name => {
            if (typeof name !== 'string') return name;
            return name.trim().replace(/[^a-zA-Z0-9_]/g, '').toLowerCase()
        };

        $scope.fillInSystemName = () => {
            if (!$scope.system_name && $scope.station_name) {
                let stripedStationName = sanitizeSystemName($scope.station_name);

                $scope.system_name = stripedStationName;

                $scope.checkIfSystemNameExists(stripedStationName);
            }
        };

        $scope.sanitizeSystemName = () => {
            $scope.system_name = sanitizeSystemName($scope.system_name);
        };

        $scope.confirmDialog = () => {
            $scope.buttonDisabled = true;

            let data = {
                station_name: $scope.station_name,
                system_name: $scope.system_name,
                timezone: $scope.timezone,
                language: $scope.language,
                organisation_id: organisation.id
            };

            $http.post('/station/add', data)
                .then(() => {
                    $scope.buttonDisabled = false;
                    this.confirmButton();
                }).catch((response) => {
                // Extract Laravel errors
                Object.getOwnPropertyNames(response.data).forEach((fieldName) => {

                    response.data[fieldName].forEach((message) => {

                        $scope.status.errorMessages.push(message);
                    });
                });

                $scope.status.error = true;
                $scope.status.sending = false;
                $scope.buttonDisabled = false;
            })
        };

    }

    cancelButton() {
        this.$mdDialog.cancel();
    }

    confirmButton() {
        this.$mdDialog.hide(this.$scope.station_name);
    }
}


/*
 * Inject dependicies
 */
stationAdd_ctrl.$inject = ['$scope', '$mdDialog', '$http', 'organisation'];


/*
 * Browsify connection: execute controller
 */
module.exports = stationAdd_ctrl;
